import { NavLink, useParams } from "react-router-dom";
import { useContext } from "react"
import { UALContext } from 'ual-reactjs-renderer';
import { useMantineTheme, createStyles, Container } from "@mantine/core";
import { CaretRight } from "tabler-icons-react";
import { match } from "assert";

const ucfirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


const useStyles = createStyles((theme) => ({
    breadcrumb: {
       fontSize: '10pt',
       fontFamily: 'Poppins',
       textTransform: 'uppercase',
    },
    breadcrumbLink: {
        textDecoration: 'none',
    }
}));

export const BreadcrumbTrail = ({ breadcrumbs, ignore, filter }) => {
    const theme = useMantineTheme()
    const { classes } = useStyles()
    let filteredBreadcrumbs = breadcrumbs.filter(({match})=>!ignore.includes(match.pathname))
    if ( filter ) {
        filteredBreadcrumbs = filteredBreadcrumbs.filter(({match})=>filter(match))
    }
    if ( filteredBreadcrumbs.length == 1 ) { return (<></>) }
    return (
      <Container my='md' mx='xs'>
        {filteredBreadcrumbs.map(({
          match,
          breadcrumb
        },i) => (
          <span className={classes.breadcrumb} key={match.pathname}>
            {
                ( filteredBreadcrumbs.length == (i+1) )
                ? breadcrumb
                :
                <>
                    <NavLink to={match.pathname} className={classes.breadcrumbLink}>{breadcrumb}</NavLink> &gt;&nbsp;
                </>
            }
          </span>
        ))}
      </Container>
    );
};

export const VerifyAssetBreadcrumb = ({match}) => {
    return (
        <span>Verify Asset {match.params.asset_id}</span>
    )
}
export const CrowdsaleBreadcrumb = ({match}) => {
    return (
        <span>Buy {match.params.symbol}</span>
    )
}
export const UserBreadcrumb = () => {
    const ual = useContext(UALContext) as any;
    return (
        <span>{ual?.activeUser?.accountName ?? 'User'}</span>
    )
}
export const ModeBreadcrumb = ({match}) => {
    return (
        <span>{ucfirst(match.params.mode)}</span>
    )
}
export const AssetBreadcrumb = ({match}) => {
    return (
        <span>Asset {match.params.id}</span>
    )
}
export const TemplateBreadcrumb = ({match}) => {
    return (
        <span>Template {match.params.id}</span>
    )
}
export const DropBreadcrumb = ({match}) => {
    return (
        <span>{ucfirst(match.params.type)} Drop {match.params.id}</span>
    )
}
export const CollectionBreadcrumb = ({match}) => {
    return (
        <span>Collection {match.params.name}</span>
    )
}
export const CollectionCreatorBreadcrumb = ({match}) => {
    return (
        <span>Manage Collection {match.params.name}</span>
    )
}
